import { createBrowserHistory } from "history"
import { useLocation } from "react-router-dom";
import React from "react";

export const history = createBrowserHistory();
